import * as React from "react";
import { Badge, Box } from "@amzn/awsui-components-react";
import { useInstanceById } from "../../../contexts/InstanceDataContext";
import { useInstanceState } from "../../instance/instance-store";
import { useCrossInstanceSearch } from "../../../hooks/use-cross-instance-search";

interface SearchInstanceBadgeProps {
    instanceId?: string;
}

export const SearchInstanceBadge: React.FC<SearchInstanceBadgeProps> = ({ instanceId }) => {
    const { instance } = useInstanceById(instanceId);
    const { instanceId: currentInstanceId } = useInstanceState();
    const isCrossInstanceSearchEnabled = useCrossInstanceSearch();

    if (!instanceId || !isCrossInstanceSearchEnabled) {
        return null;
    }

    const instanceName = instance?.name;
    const isCurrentInstance = instanceId === currentInstanceId;
    const badgeColor = isCurrentInstance ? undefined : "grey";

    return (
        <Box variant="small" color="text-body-secondary" margin={{right: "xs"}} padding="n">
            <Badge
                color={badgeColor}
                className={isCurrentInstance ? "awsui-badge-orange" : undefined}
            >
                {instanceName || instanceId}
            </Badge>
        </Box>
    );
};
